<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight task-square">
        <task-info demandType="0"></task-info>
        <div class="edit-area">
            <hint-real-name @getUserIdentity="getUserIdentity"></hint-real-name>
            <real-name-pop ref="realNamePop"></real-name-pop>
            <div class="header">
                <div class="header-title">图文投稿</div>
            </div>
            <!-- 图文内容可编辑区域[[ -->
            <div class="edit-content">
                <div class="title">
                    <input type="text" class="title-textarea" rows="1" @focus="tips.title=false" v-model="form.title"
                        maxlength="30" placeholder="请输入标题内容（30个字以内）">
                    <span class="wordsNum">{{form.title.length}}/30</span>
                    <p class="error-prompt" v-show="tips.title">标题不能为空，不能少于10个字</p>
                </div>
                <tgl-richeditor :id="richOptions.id" :buttons="richOptions.buttons" :height="richOptions.height"
                    ref="richeditor">
                </tgl-richeditor>
                <div class="img-upload">
                    <tgl-image-cloud-upload style="display: inline-block" btnId='pic1' :minWidth="640"
                        :minHeight="360" :isCrop="true" :maxSize="6*1024*1024" ref="imgUpload" @completed="imageUploadCompleted"
                        @deletePic="deletePic">
                        <template #text>
                            <div class="upload-text">点击上传封面图片</div>
                        </template>
                    </tgl-image-cloud-upload>
                    <div class="upload-tips">
                        上传高清、无二维码、无黑边的封面图、将获得更多推荐机会
                        <br>
                        支持最小尺寸640*360，最大6MB，格式为jpg/png的图片
                    </div>
                    <p class="error-prompt" v-show="tips.cover">未上传封面图片</p>
                </div>
                <div class="declaration">
                    <i class="ico" :class="form.isOrigin ? 'ico-checkbox-checked' : 'ico-checkbox'" @click="form.isOrigin == 0 ? form.isOrigin=1 : form.isOrigin=0"></i>
                    <div class="declaration-text" @click="form.isOrigin == 0 ? form.isOrigin=1 : form.isOrigin=0">声明原创（获得更高收益与曝光）</div>
                    <i class="ico ico-question"></i>
                    <div class="g-tooltip declaration-tips">
                        <div class="g-tooltip-arrows-down"></div>
                        <div class="tooltip-content">
                            伪造原创声明，将损失您的信用分和收益哦
                        </div>
                    </div>
                </div>
            </div>
            <media-select demandType="0" ref="mediaSelect" :mediaInfo="mediaSelectInfo" @changeAuth="sendTitleCover"></media-select>
            <!-- 图文内容可编辑区域]] -->
            <div class="footer-bar">
                <div class="footer-bar-btn">
                    <div class="g-bottom-btn btn-group">
                        <a class="button f-fr" @click="back">返回</a>
                        <a class="button f-fr" @click="preview">预览</a>
                        <a class="button f-fr" @click="savePicture('draft')">存草稿</a>
                        <a class="button bg-btn f-fr" @click="savePicture('submit')">提交</a>
                    </div>
                </div>
            </div>
        </div>
        <content-preview ref="contentPreview"></content-preview>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/contribute/task.scss';
</style>
<script>
import taskInfo from './_task_info';
import hintRealName from 'Components/v4/hint/real_name.vue';
import mediaSelect from './media_select.vue';
import realNamePop from 'Components/v4/pop/real_name_pop.vue';
import contentPreview from 'Components/v4/pop/content_preview';
import {
    TaskAddArticle, TaskDetail, ArticleDetail, TaskEditArticleDraft, ActivityDraftInfo
} from 'Services/getData';
export default {
    data() {
        return {
            form: {
                missionId: 0,
                title: '',
                content: '',
                cover: '',
                isOrigin: 0,
                mediaInfo: [],
                draftId: 0,
                articleId: 0
            },
            tips: {
                title: false,
                content: false,
                cover: false
            },
            coverUrl: '',
            task: {},
            isSubmit: true,
            userIdentityData: {
                tglVerify: {
                    code: ''
                },
                flowUser: {}
            },
            edit_times: 0,
            total_sec: Date.now(),

            mediaSelectInfo: [],
            richOptions: {
                id: 'rich',
                buttons: [
                    'h1', 'bold', 'italic', 'underline', 'blockquote', 'hr', '|',
                    'font', 'size', 'color', '|',
                    'insertorderedlist', 'insertunorderedlist', 'justify', '|',
                    'link', 'table', 'image', 'video', '|',
                    'removeFormat', 'undo', 'redo', '|',
                    'fullscreen'
                ],
                height: 320
            }
        }
    },
    components: {
        hintRealName,
        realNamePop,
        taskInfo,
        mediaSelect,
        contentPreview
    },
    mounted() {
        this.form.missionId = this.getTaskId();
        this.getArticleId();
        this.getDetail();
        this.getArticle();
    },
    methods: {
        preview() {
            let data = Object.assign({}, this.form);
            data.articleTitle = data.title
            data.creator = this.$store.state.realUserInfo.userName;
            data.created = `${new Date().toLocaleDateString()} ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`;
            data.summary = this.form.content;
            this.form.content = this.$refs.richeditor.getHtml()
            data.articleContent = this.form.content;
            data.articleType = 0;
            this.$refs.contentPreview.contributeInfo(data);
        },
        sendTitleCover() {
            this.$refs.mediaSelect.getTitleCover(this.form.title, this.coverUrl);
        },
        showqqVerify() {
            this.$refs.realNamePop.showqqVerify = true;
        },
        showTglAndQqVerify() {
            this.$refs.realNamePop.showTglAndQqVerify = true;
        },
        async getUserIdentity(data) {
            this.userIdentityData = data;
            this.toShowUserIdentity();
        },
        toShowUserIdentity() {
            if (!this.userIdentityData.qqVerify) {
                this.showqqVerify();
                return false;
            }
            if (this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false) {
                this.showTglAndQqVerify();
                return false;
            }
            return true;
        },
        getArticleId() {
            if (this.$route.query.type === 'draft') {
                this.form.draftId = this.$route.params.articleId
                return;
            }
            if (this.$route.params.articleId) {
                this.form.articleId = this.$route.params.articleId;
            }

        },
        getTaskId() {
            return this.$route.params.taskId;
        },
        getParams(selectMediaList, autoAuth) {
            this.form.mediaInfo = [];
            selectMediaList.forEach((v, k) => {
                console.log(this.form.mediaInfo)
                let mediaInfo = {};
                mediaInfo.accountId = v.curAccount.id;
                if (autoAuth) {
                    mediaInfo.title = '';
                    mediaInfo.cover = '';
                    mediaInfo.summary = '';
                } else {
                    mediaInfo.title = v.title;
                    mediaInfo.cover = v.cover;
                    mediaInfo.summary = v.summary;
                }
                this.form.mediaInfo.push(mediaInfo);
            })
            this.form.mediaInfo = JSON.stringify(this.form.mediaInfo);
        },
        async savePicture(type) {
            this.$refs.mediaSelect.saveDefaultMedia()
            this.edit_times++;
            if (!this.toShowUserIdentity()) {
                return false;
            }
            this.form.content = this.$refs.richeditor.getHtml()
            if (!this.form.missionId) {
                this.$alert("任务不存在");
                return false;
            }
            if (!this.form.title || this.form.title < 10) {
                this.tips.title = true;
                this.$alert('标题不能为空，不能少于10个字')
                return false;
            }
            if (!this.form.content) {
                this.$alert("正文不能为空");
                return false;
            }
            if (!this.form.cover) {
                this.$alert('未上传封面图片')
                this.tips.cover = true;
                return false;
            }
            let {
                mediaInfo, autoAuth
            } = this.$refs.mediaSelect.getSelectMediaList();
            this.getParams(mediaInfo, autoAuth);
            if (this.$refs.mediaSelect.showPublish && this.form.mediaInfo.length <= 2) {
                this.$alert("请选择渠道");
                return false;
            }
            if (this.isSubmit) {
                let reqStartTime = Date.now();
                this.isSubmit = false;
                let res = null;
                // if (this.form.articleId == 0) {
                //     res = await TaskAddArticle(this.form);
                // } else {
                //     res = await TaskEditArticle(this.form);
                // }
                switch (type) {
                    case "submit":
                        res = await TaskAddArticle(this.form);
                        break;
                    case "draft":
                        res = await TaskEditArticleDraft(this.form);
                        break;
                }
                this.$common.reportContribute(
                    res.data.code == 0 ? 1 : 0,
                    res.data.info,
                    this.edit_times,
                    'task',
                    reqStartTime,
                    this.total_sec,
                );
                if (res.data.code == 0) {
                    this.$alert('操作成功');
                    // this.$router.push({name:'v4-manage-content',params:{tabId:3}});
                    if (type === 'submit') {
                        this.$router.push({
                            name: 'v4-task-detail', params: {
                                detailId: this.form.missionId
                            }
                        });
                    } else {
                        this.form.draftId = res.data.data
                    }
                }
                this.isSubmit = true;
            }
        },
        imageUploadCompleted(data) {
            this.form.cover = data.id;
            this.coverUrl = data.url;
        },
        deletePic() {
            this.form.cover = '';
            this.coverUrl = '';
        },
        async getDetail() {
            let res = await TaskDetail({
                missionId: this.form.missionId
            });
            if (res.data && res.data.code == 0) {
                this.task = res.data.data;
                if (this.task.id == undefined) {
                    this.$alert('任务不存在');
                } else if (this.task.mission_status != 30) {
                    this.$alert('任务已结束不能投稿');
                }
            }
        },
        back() {
            this.$confirm('返回内容将不被保存，确认返回？').then(() => {
                this.$router.go(-1);
            }).catch((e) => {
            });
        },
        async getArticle() {
            if (this.form.draftId) {
                let ret = await ActivityDraftInfo({
                    draftId: this.form.draftId
                });
                if (ret.status == 200 && ret.data.code == 0) {
                    let article = ret.data.data;
                    this.form.isOrigin = article.isOriginal;
                    this.form.title = article.articleTitle;
                    this.form.content = this.$refs.richeditor.setHtml(article.articleContent);
                    this.form.cover = article.attachments.id;
                    this.$refs.imgUpload.setPic(article.attachments.attachmentUrl);
                    this.mediaSelectInfo = article.mediaDistribute;
                    this.coverUrl = article.attachments.attachmentUrl;
                    if (!this.mediaSelectInfo.length) {
                        this.$refs.mediaSelect.getDefaultMedia()
                    }
                }
                return;
            }
            if (this.form.articleId) {
                let ret = await ArticleDetail(this.form.articleId);
                if (ret.status == 200 && ret.data.code == 0) {
                    let article = ret.data.data;
                    this.form.isOrigin = article.isOriginal;
                    this.form.title = article.articleTitle;
                    this.form.content = this.$refs.richeditor.setHtml(article.articleContent);
                    this.form.cover = article.attachments[0].id;
                    this.$refs.imgUpload.setPic(article.attachments[0].attachmentUrl);
                    this.mediaSelectInfo = article.mediaDistribute;
                    this.coverUrl = article.attachments[0].attachmentUrl;
                    if (!this.mediaSelectInfo.length) {
                        this.$refs.mediaSelect.getDefaultMedia()
                    }
                }
                return;
            }
            this.$refs.mediaSelect.getDefaultMedia()
        }
    }
}
</script>